
import React from 'react';
import './style.css'


// eslint-disable-next-line react/prop-types
function Card({desc, title, ...props}) {

  return <div className='card' {...props}>
    <div className='card-content'>
      <h1 style={{textTransform: 'uppercase'}}>
        {title}
      </h1>
      <p>{desc}</p>
      <p style={{fontStyle: 'italic', textDecoration:  title === 'PROJETO DE INTERIORES' ?'none' :'underline'}}> 
        { title === 'PROJETO DE INTERIORES' ? 'Entre em contato e' :''} saiba mais...
      </p>

    </div>
  </div>
}

export default Card;
